import { useState, useMemo, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import MangaCard from '@/components/feature/MangaCard';
import Breadcrumb from '@/components/base/Breadcrumb';
import SEOSchema from '@/components/base/SEOSchema';
import ScrollToTop from '@/components/base/ScrollToTop';
import { mangaList, categories } from '@/mocks/mangaData';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentSlug = slug || 'all';
  const currentCategory = categories.find((c) => c.slug === currentSlug) || categories[0];

  const filteredManga = useMemo(() => {
    if (currentSlug === 'all') return mangaList;
    return mangaList.filter((m) => m.category === currentSlug);
  }, [currentSlug]);

  const [activeSlug, setActiveSlug] = useState(currentSlug);

  useEffect(() => {
    setActiveSlug(currentSlug);
  }, [currentSlug]);

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: currentCategory.name },
  ];

  return (
    <>
      <ScrollToTop />
      <SEOSchema type="Organization" />
      <SEOSchema type="WebSite" />
      <SEOSchema
        type="WebPage"
        data={{
          name: `${currentCategory.name}漫画 - 虫虫漫画`,
          description: `虫虫漫画${currentCategory.name}分类，海量正版韩国${currentCategory.name}漫画在线阅读，高清画质流畅体验。`,
          url: window.location.origin + `/category/${currentSlug}`,
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <Breadcrumb items={breadcrumbItems} />

            <div className="mb-8">
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
                {currentCategory.name}漫画
              </h1>

              <div className="flex flex-wrap gap-2">
                {categories.map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className={`inline-flex items-center px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                      activeSlug === cat.slug
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
                    }`}
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>

            {filteredManga.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5 pb-16">
                {filteredManga.map((manga) => (
                  <MangaCard key={manga.id} {...manga} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <i className="ri-emotion-sad-line text-5xl text-foreground-300 w-12 h-12 flex items-center justify-center mx-auto mb-4"></i>
                <p className="text-foreground-500">该分类暂无漫画，敬请期待！</p>
              </div>
            )}
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}